var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    transform: "translate(300 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.449 189.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.676 11.187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.993,19.367H9.482a.482.482,0,0,1,0-.964h2.511a1.448,1.448,0,0,0,1.446-1.446V13.482a.482.482,0,1,1,.964,0v3.475A2.413,2.413,0,0,1,11.993,19.367Z",
    transform: "translate(-9 -13)",
    fill: "#656d88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.993,19.567H9.482a.682.682,0,0,1,0-1.364h2.511a1.247,1.247,0,0,0,1.246-1.246V13.482a.682.682,0,0,1,1.364,0v3.475A2.613,2.613,0,0,1,11.993,19.567ZM9.482,18.6a.282.282,0,0,0,0,.564h2.511a2.212,2.212,0,0,0,2.21-2.21V13.482a.282.282,0,0,0-.564,0v3.475A1.648,1.648,0,0,1,11.993,18.6Z",
    transform: "translate(-9 -13)",
    fill: "#656d88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.187 8.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.432,10.964h-6.95a.482.482,0,1,1,0-.964h6.95a.482.482,0,1,1,0,.964Z",
    transform: "translate(-15 -10)",
    fill: "#656d88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.432,11.164h-6.95a.682.682,0,0,1,0-1.364h6.95a.682.682,0,0,1,0,1.364Zm-6.95-.964a.282.282,0,0,0,0,.564h6.95a.282.282,0,0,0,0-.564Z",
    transform: "translate(-15 -10)",
    fill: "#656d88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.712,21.446a1.837,1.837,0,0,1-.615-.105L1.323,19.416A1.926,1.926,0,0,1,0,17.59V2.928A1.93,1.93,0,0,1,1.928,1a1.8,1.8,0,0,1,.616.106L8.317,3.03A1.924,1.924,0,0,1,9.64,4.856V19.518A1.93,1.93,0,0,1,7.712,21.446ZM1.928,1.964a.965.965,0,0,0-.964.964V17.59a.964.964,0,0,0,.663.912L7.411,20.43a.961.961,0,0,0,1.265-.912V4.856a.96.96,0,0,0-.663-.911L2.229,2.017a.887.887,0,0,0-.3-.053Z",
    transform: "translate(0 -1)",
    fill: "#656d88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.712,21.646a2.034,2.034,0,0,1-.682-.117L1.259,19.606A2.125,2.125,0,0,1-.2,17.59V2.928A2.13,2.13,0,0,1,1.928.8,2,2,0,0,1,2.61.917L8.381,2.84A2.123,2.123,0,0,1,9.84,4.856V19.518A2.13,2.13,0,0,1,7.712,21.646ZM1.928,1.2A1.73,1.73,0,0,0,.2,2.928V17.59a1.725,1.725,0,0,0,1.186,1.636L7.16,21.151a1.642,1.642,0,0,0,.552.095A1.73,1.73,0,0,0,9.44,19.518V4.856A1.723,1.723,0,0,0,8.254,3.22L2.481,1.3l-.005,0A1.6,1.6,0,0,0,1.928,1.2ZM7.721,20.684a1.125,1.125,0,0,1-.377-.066l-5.78-1.927a1.164,1.164,0,0,1-.8-1.1V2.928A1.165,1.165,0,0,1,1.928,1.764a1.087,1.087,0,0,1,.368.065l5.78,1.926a1.159,1.159,0,0,1,.8,1.1V19.518a1.161,1.161,0,0,1-.343.821A1.14,1.14,0,0,1,7.721,20.684ZM1.928,2.164a.765.765,0,0,0-.764.764V17.59a.764.764,0,0,0,.527.722L7.474,20.24a.733.733,0,0,0,.247.044.753.753,0,0,0,.528-.227.764.764,0,0,0,.227-.54V4.856a.76.76,0,0,0-.526-.721L2.166,2.207A.7.7,0,0,0,1.928,2.164Z",
    transform: "translate(0 -1)",
    fill: "#656d88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.651,6.367a.482.482,0,0,1-.482-.482V2.41A1.448,1.448,0,0,0,11.723.964H1.982a.482.482,0,0,1,0-.964h9.741a2.413,2.413,0,0,1,2.41,2.41V5.885A.482.482,0,0,1,13.651,6.367Z",
    transform: "translate(-1.5)",
    fill: "#656d88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.651,6.567a.683.683,0,0,1-.682-.682V2.41a1.247,1.247,0,0,0-1.246-1.246H1.982a.682.682,0,1,1,0-1.364h9.741a2.613,2.613,0,0,1,2.61,2.61V5.885A.683.683,0,0,1,13.651,6.567ZM1.982.2a.282.282,0,1,0,0,.564h9.741A1.648,1.648,0,0,1,13.369,2.41V5.885a.282.282,0,0,0,.564,0V2.41A2.212,2.212,0,0,0,11.723.2Z",
    transform: "translate(-1.5)",
    fill: "#656d88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.626 5.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.482,12.986a.482.482,0,0,1-.341-.822l2.17-2.17-2.17-2.17a.482.482,0,0,1,.682-.682l2.511,2.511a.482.482,0,0,1,0,.682l-2.511,2.511A.483.483,0,0,1,20.482,12.986Z",
    transform: "translate(-20 -7.002)",
    fill: "#656d88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.482,13.186A.682.682,0,0,1,20,12.022l2.028-2.028L20,7.966A.682.682,0,0,1,20.964,7l2.511,2.511a.683.683,0,0,1,0,.964l-2.511,2.511A.68.68,0,0,1,20.482,13.186Zm0-5.984a.282.282,0,0,0-.2.481l2.17,2.17a.2.2,0,0,1,0,.283l-2.17,2.17a.282.282,0,0,0,0,.4.284.284,0,0,0,.4,0l2.51-2.51a.282.282,0,0,0,0-.4L20.681,7.284A.28.28,0,0,0,20.482,7.2Z",
    transform: "translate(-20 -7.002)",
    fill: "#656d88"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutNew);
export default __webpack_public_path__ + "static/media/logoutNEW.7cf0c37e16a0b35cb124202282cf586b.svg";
export { ForwardRef as ReactComponent };